<section class="page-wrap animated fadeIn">

  <header class="pattern-header">
    Atlanta Delivery Schedule
  </header>

  <div class="d-flex justify-content-center align-items-center mb-5">
    <div class="landing-container">
      @defer (when !isLoading()) {
      <mat-tab-group mat-stretch-tabs="false" disableRipple="true" mat-align-tabs="start">
        @for (item of memberships(); track $index) {
        <mat-tab [label]="item.name">

          <div class="delivery-header mt-3">
            <img src="/assets/images/landing/atlanta-delivery/{{item.img}}" alt="Image of {{item.title}}">
            <p class="h6-regular mb-0" [innerHTML]="item.subtitle"></p>
          </div>

          <div class="delivery-header">
            <h3 class="title">
              {{item.title}}
            </h3>

            @if (!hasSession() && !item.isPickup) {
            <button class="btn btn-outline-primary" type="button" (click)="openModalCheckAddress()">
              Check your delivery day
            </button>
            }
          </div>

          <div class="delivery-panel">
            <iframe class="delivery-panel__map" [src]="item.map" title="Atlanta Delivery Schedule Map"></iframe>
            <div class="delivery-panel__schedule">
              @for (day of item.days; track $index) {
              <details name="days">
                <summary class="h5-semibold">
                  <span class="material-icons">chevron_right</span>
                  {{day.deliveryDay}}
                </summary>
                <div class="d-flex flex-column gap-4 mt-3 animated fadeInDown">
                  @for (zone of day.zones; track $index) {
                  <div class="delivery-card">
                    <header>
                      <span class="h6-bold">
                        {{zone.name}}
                      </span>
                    </header>
                    <div class="info">
                      @if (zone.deliveryWindow) {
                      <div class="info__item">
                        <span class="material-symbols-outlined text-primary">
                          alarm
                        </span>
                        <span class="h6-regular">
                          {{zone.deliveryWindow}}
                        </span>
                      </div>
                      }
                      @if (zone.locationAddress) {
                      <div class="info__item">
                        <span class="material-symbols-outlined text-primary">
                          location_on
                        </span>
                        <span class="h6-regular">
                          {{zone.locationAddress}}
                        </span>
                      </div>
                      }
                      @if (zone.additionalInfo) {
                      <div class="info__item">
                        <span class="material-symbols-outlined text-primary align-self-baseline">
                          info
                        </span>
                        <span class="h6-regular" [innerHTML]="zone.additionalInfo">
                        </span>
                      </div>
                      }
                    </div>
                  </div>
                  }
                </div>
              </details>
              }
            </div>
          </div>

        </mat-tab>
        }
      </mat-tab-group>
      } @placeholder {
      <div class="loading-animation-content">
        <div class="loader">
          @for (item of [0,0,0,0,0]; track $index) {
          <div class="bg-secondary"></div>
          }
        </div>
      </div>
      }
    </div>
  </div>

</section>